import { render, staticRenderFns } from "./IKPRNode.vue?vue&type=template&id=56840d7e&scoped=true&"
import script from "./IKPRNode.vue?vue&type=script&lang=js&"
export * from "./IKPRNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56840d7e",
  null
  
)

export default component.exports